import { TFunction } from 'i18next'
import { ModbusTcpChargingStation } from 'src/Libs/flow/installation/forms'
/**
 * Utils for the Options in the selection-inputs in the ModbusTcp-file
 */

/**
 * Options for the Modbus-PhaseManagement-Selection
 */
export const getPhaseManagementOptions = (t: TFunction): Options<ModbusTcpChargingStation['phaseManagement']> => [
  { value: 'AutoPhaseSwitch', label: t('installation.evseEditor.phaseManagement.autoPhaseSwitch') },
  { value: '1PhBlocked', label: t('installation.evseEditor.phaseManagement.1PhBlocked') },
  { value: '3PhBlocked', label: t('installation.evseEditor.phaseManagement.3PhBlocked') },
]

/**
 * Options for the Modbus-PhaseRotation-Selection
 */
export const phaseMappingOptions: Options<ModbusTcpChargingStation['phaseMapping']> = [
  { value: '123', label: 'L1-L2-L3' },
  { value: '132', label: 'L1-L3-L2' },
  { value: '231', label: 'L2-L3-L1' },
  { value: '213', label: 'L2-L1-L3' },
  { value: '312', label: 'L3-L1-L2' },
  { value: '321', label: 'L3-L2-L1' },
]

/**
 * Options for the Modbus-Mid-Meter-Configuration
 */
export const getMidMeterOptions = (t: TFunction): Options<ModbusTcpChargingStation['midMeter']> => [
  { value: 'no mid meter', label: t('installation.evseEditor.useMidMeter.no-mid-meter') },
  { value: 'ECP140D', label: t('installation.evseEditor.useMidMeter.with-mid-ECP140D') },
  { value: 'ECP380D', label: t('installation.evseEditor.useMidMeter.with-mid-ECP380D') },
]

type AccessManagementOptions = ModbusTcpChargingStation['accessManagementOptions']
/**
 * Options for the Modbus-Access-Management-Selection
 */
export const getAccessManagementOptions = (t: TFunction, isWittyLink: boolean, isOcppEnabled: boolean): Options<AccessManagementOptions> => [
  ...(isWittyLink
    ? []
    : [
        {
          value: 'key',
          label: t('installation.evseEditor.accessManagement.key'),
          description: t('installation.evseEditor.accessManagement.keyDescription'),
        } as Options<AccessManagementOptions>[number],
      ]),
  {
    value: 'freeAccess',
    label: t('installation.evseEditor.accessManagement.freeAccess'),
    description: t('installation.evseEditor.accessManagement.freeAccessDescription'),
    disabled: isOcppEnabled,
  },
  {
    value: 'badge',
    label: t('installation.evseEditor.accessManagement.badge'),
    description: t('installation.evseEditor.accessManagement.badgeDescription'),
  },
]
